import React, { useCallback } from 'react';
import { useAppDispatch, useAppSelector, useEffect } from 'hooks';
import { DataStatus } from 'types/enums';
import { facilityActions } from 'utils/store';
import styles from './styles.module.sass';
import { FacilityItem } from './components';
import { ScreenTitle } from 'components';

export const Practice = () => {
  const { data, status: userStatus } = useAppSelector(({ user }) => user);
  const { accountFacilities, status: facilityStatus } = useAppSelector((state) => state.facility);
  const dispatch = useAppDispatch();
  const isLoading = userStatus === DataStatus.LOADING || facilityStatus === DataStatus.LOADING;
  const userId = data?.id;

  useEffect(() => {
    if (userId) {
      dispatch(facilityActions.getFacilityByUserId(userId));
    }
  }, [userId, dispatch]);

  const generateContent = useCallback(() => {
    if (isLoading) {
      return <h2 className={styles.title}>Loading...</h2>;
    }

    if (!accountFacilities?.length) {
      return <h2 className={styles.title}>There is no facility</h2>;
    }

    return (
      <>
        <ScreenTitle title='Your facilities:' />
        {accountFacilities.map((facility) => (
          <FacilityItem key={facility.id} facility={facility} />
        ))}
      </>
    );
  }, [accountFacilities, isLoading]);

  return generateContent();
};
